<app-header></app-header>
<section class="notd__grid wrapper--centered wrapper--organized">
  <nav class="navigation-bar">
    <ul>
      <li><a [routerLink]="['/']" i18n="@@GLOBAL-HOME">Home</a></li>
      <li><a [routerLink]="['/faq']" i18n="@@GLOBAL-FAQ">FAQ</a></li>
    </ul>
  </nav>

  <h2 class="subpage-title" i18n="@@FAQ-001">Notd FAQs</h2>

  <h3>What is Notd?</h3>
  <p>
    Notd is a new kind of publishing network designed to benefit both publishers and readers. We’ll never sell ads or gather personal information.
  </p>

  <p>
    <b>Publishers</b> can write on any topic, completely free of charge. A publisher chooses how much to charge readers to subscribe to their stream (or they can offer free content). If they charge at least 10 cents per month, they keep 90% of the revenue. Notd keeps 10% just to keep the network running. If they charge less, we keep one cent per month, per subscriber.
  </p>
  <p>
    <b>Readers</b> subscribe to individual streams and can customize their feed, so they’ll have everything they enjoy in one place. All new readers get $3 in free credit, so they can check out most streams without even providing a credit card.­
  </p>
  <p>
    Many streams cost only pennies per month and all streams have excerpts that are free to read. So, what are you waiting for? Sign up for a free Notd account and get started publishing or reading!
  </p>

  <h3>Reader’s FAQ </h3>

  <h4>What subscription frequencies do you offer? </h4>
  <p>
    You can subscribe by the month or the year.
  </p>

  <h4>What do I need to subscribe?</h4>
  <p>You’ll need to open a free Transact account (see next FAQ to log into Notd and to pay for subscriptions. Your Transact and Notd accounts use the same email address. If you want to comment on notes or join a community stream, you’ll also need to agree to our community standards. </p>

  <h4>What is Transact?</h4>
  <p>
    Transact is a web-based debit card for digital media. It allows payments as small as one cent without the bank fees that consume or exceed the value of the transaction, thus enabling an entirely new economy. Deposit as little as one dollar in your Transact account and spend it on web content a quarter, dime, nickel, or even a penny at a time. Transact is extremely secure and fast; processing a payment typically takes one second.
  </p>
  <p>
    Transact (for digital payments), Notd (our publishing network), and Post (for video publishers and creators) were developed by Xsact, Inc. in Santa Barbara, CA. They are designed to work together seamlessly together, creating a digital media ecosystem that doesn't rely on advertising.
  </p>

  <h4>Can I get a refund for a subscription?</h4>
  <p>No, sorry. At least for now, most subscriptions are so inexpensive that it would cost more for us to process a refund than the actual refund! We suggest subscribing for a month until you are sure you like it enough to subscribe for a year.</p>

  <h4>How do I listen to a podcast?</h4>
  <p>For more info how to add and use podcast on your app <a class="link" [routerLink]="['/how-to-use-podcast']">click here</a>.</p>

  <h4>What is a community stream?</h4>
  <p>Community steams are designed to let subscribers share information with each other. Community subscribers can post notes and/or reply to a note in a thread. (In regular streams, only the publisher can post notes, and subscribers can only comment.) </p>

  <h4>Is anyone allowed to join a community stream?</h4>
  <p>A stream’s publisher can choose to keep a community stream private, so that only invited people can join, or to make it public, so that anyone can join. The publisher decides what kind of stream it will be and how much it costs to subscribe.</p>

  <h4>What is a team account? </h4>
  <p>A team account allows a publisher to curate and aggregate notes from multiple writers. This allows a publisher to specialize (for example, on a topic or a target audience), like a newspaper or magazine does. It also allows a group of writers to band together and offer a “bundle” to their subscribers.</p>



<!--
  <h4 i18n="@@FAQ-009">
    What are those grey buttons on the left side for?
  </h4>

  <article i18n="@@FAQ-010">
    There are several different classes of notes, and these buttons allow you to filter notes quickly to find the type of content you are looking for.  Within a form you can also select a category. For example, maybe you are looking for news and not opinions, but you don't want to see all the news, just a specific subject. These buttons narrow searches quickly. Once you have discovered a favorite group of streams that you subscribe or follow, you can hide the buttons so they are only visible when you search for new streams or notes.
  </article>
-->
  <h4 i18n="@@FAQ-011">
    What personal data do you collect?
  </h4>

  <p>
    Because we don’t sell ads, we don’t monitor any of your activity. The streams we show you aren’t based on your history, but rather are what’s popular or what you are viewing  <i>at that moment.</i>. We really don’t know anything about you; we figure that’s how you like it.
  </p>
  <p>
    We do keep track of subscriptions. If you charge for a stream, we track how much people spend on your stream so we can pay you. If you are a subscriber, we keep track of your subscriptions.
  </p>

  <h4 i18n="@@FAQ-013">
    Are there any ads on Notd? 
  </h4>

  <article>
    <p>
      We don’t sell ads, but publishers are permitted to embed ads in their notes in the form of text or images. There are no video or audio ads permitted. It’s up to subscribers whether they will tolerate ads in a stream.
    </p>
  </article>

  <h4 i18n="@@FAQ-016">
    Why can’t politicians have fundraising streams?
  </h4>
  <p>
    Complying with complicated campaign finance laws would make our service more expensive for everyone, so we don’t allow anyone who holds or is running for public office to charge more than one cent per month. (Only streams costing two cents or more can make money for the publisher.)
  </p>

  <h4 i18n="@@FAQ-018">
    Can we share notes with non-subscribers? 
  </h4>

  <p>
    Yes. If you share a link with a non-subscriber, they will see the note excerpt. 
  </p>

  <h4 i18n="@@FAQ-020">
    What is the difference between Display Name and Username? 
  </h4>

  <p>
    Publishers use a display name. Commenters use a username so they can maintain anonymity. For security purposes, you can log in with your email address or your username, but not your display name.
  </p>

  <h4 i18n="@@FAQ-022">
    If a stream’s publisher wants to offer free content, why does the stream have a cost? 
  </h4>

  <article>
    Somebody must pay for servers, bandwidth, and the people who build and maintain Notd. We don’t have ads, so the cost is distributed among the readers, proportional to the number of subscriptions they have.
  </article>

  <h4 i18n="@@FAQ-026">
    Can I be notified when there are new notes on streams that I subscribe to?
  </h4>

  <p>
    Yes, once your subscribed to the stream, you may click on the bell notification icon to receive emails of new content.
  </p>

  <h4 i18n="@@FAQ-030">
    Can any note be tagged as news?
  </h4>

  <p>
    Only if it’s actually news! Which means it can't be opinion or fabricated. If we determine either is the case, the note may be deleted or placed in a different note type. Repeated abuse of the “news” type will result in account deletion. 
  </p>

  <h4 i18n="@@FAQ-032">
    Does Notd edit content?
  </h4>

  <p>
    No. We may change the note if it’s inappropriately typed (for example, if we notice an opinion is typed as news, we may change it), but we don't make edits. 
  </p>


 <h3 i18n="@@FAQ-041">
  Publisher’s FAQ
 </h3>

 <h4>
    How can I get started publishing on Notd?
 </h4>

  <article>
    <p>
    Read our note on <a class="link" href="https://notd.io/n/CreatingYourFirstStream" target="_blank">creating your first stream</a>,
    and <a class="link" href="https://notd.io/n/PublishingTips" target="_blank"> publishing tips.</a>
    </p>
  </article>


  <h4>
    Can I write about anything I want? 
  </h4>

  <article>
    <p>Yes, within the community guidelines. We respect the right to free speech. Criticism is acceptable, but personal attacks are not. Simply put, we don’t want Notd to be used to incite hate or defame other people. If a reader feels that a Note violates our community guidelines, they can use the Report Note function that sits at the bottom of every note. Our team will evaluate it and, if we agree, we’ll reach out to the poster and ask them to correct the issue. Repeated abuse, though, will result in account deletion.</p>

    <p>Also, this isn't the place to post or sell porn. Like you, we know it when we see it.</p>
    <p>And, of course, you must have the rights to publish content you post. Usually that means you are the original writer and/or copyright owner. It also means you can’t post content from other sources without expressed permission, which would be illegal.</p>
    <p>
      You can read more in our <a class="link" [routerLink]="['/terms']">Terms of Service.</a>.
    </p>
  </article>



  <h4>How do I create a stream? Does it cost anything? </h4>

  <p>
    After logging into your Notd account, click on “New Note” and follow the instructions. It costs nothing to create a stream and post notes to it.
  </p>


  <h4>How do I write or upload notes?</h4>

  <p>
    Super easy. You can type directly in the text editor or copy and paste your text from a word processing or other text program. 
  </p>


  <h4>Can I write more than one stream? </h4>

  <article>
    Yes, we hope you do! Notd is a great place to explore and try things out.
  </article>

  <h4 i18n="@@FAQ-046">
    How much do people pay to subscribe to my streams?
  </h4>

  <p>
    That's up to you. The minimum price is one cent per month or 10 cents per year, but at that price, you do not receive any income. You receive revenue with any fee higher than that, even if it’s just two cents per month or 24 cents per year. You’ll determine over time what the market for your content will bear.
  </p>

  <h4 i18n="@@FAQ-050">
    Is there a limit to how much I can charge for a subscription?
  </h4>

  <article i18n="@@FAQ-051">
    No, but there is a limit to how much people will pay, of course. 
  </article>

  <h4 i18n="@@FAQ-052">
    How much do I get from the subscription revenue?
  </h4>

  <p>
    You keep 90% of each subscription. Notd Keeps 10% to maintain the network. 
  </p>

  <h4 i18n="@@FAQ-054">
    How do I see how much my streams have earned?
  </h4>

  <p>.
    Click on “My Account” in the upper left corner and select “Earnings.”
  </p>

  <h4 i18n="@@FAQ-056">
    How do I get paid?
  </h4>

  <p>
    Click on “My Account” in the upper left corner and select “Earnings.” Then click on “Transfer to Bank.” You will need to supply bank and tax information before the first transfer.  Your information is always encrypted in transit and at rest.
  </p>


  <h4>
    What is the Debate feature and how do I use it? 
  </h4>

  <p>
    A debate allows a publisher and selected people to debate the contents of your note. When writing a note, enable “Debate,” and add the username(s) of the people you want to include in the debate. After the note is published, they will have the ability to reply to the thread. 
  </p>

  <h4>
    Who can annotate a note, and how? 
  </h4>

  <p>
    Publishers and invited debaters can annotate a note by using the note editor. Select the text you want to annotate, then click "annotate" on the tool bar. An excerpt cannot be annotated.
  </p>


  <h4>
    How do I thread notes?
  </h4>

  <p>
    Click on “Reply to thread” to add a new note to that thread. 
  </p>

  <h4>
    Can I add photos to a stream and what is the photo size limit?
  </h4>

  <p>
    Yes. You can post up to 10MB of photos in one note in any stream. The photography type helps readers discover steams that focus on photography.
  </p>

  <h4>
    How do I add a photo caption? 
  </h4>

  <p>
    After you upload a photo, click or tap anywhere on the image to enter a caption below the photo. 
  </p>

</section>
<app-footer></app-footer>
